import {NgModule} from '@angular/core';
import {GnMessageService} from './message-service';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzNotificationModule } from 'ng-zorro-antd/notification';


@NgModule({
  imports: [
    NzMessageModule,
    NzNotificationModule
  ],
  providers: [GnMessageService]
})
export class GnMessageServiceModule {
}
